import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { useGetAllIndustryData, useDeleteIndustry } from "../../hooks";
import IndustriesContextMenu from "./IndustriesContextMenu";
import { WarningDeleteDialog } from "../../dialogs";

const sortable = true;
const items = [
  {
    id: "label",
    label: "Name",
    sortable,
  },
  {
    id: "customerCount", 
    label: "Customers",
    sortable,
    width: "100px", // Make count columns narrower
  },
  {
    id: "vendorCount",
    label: "Vendors", 
    sortable,
    width: "100px", // Make count columns narrower
  },
  {
    id: "actions",
    label: "",
    width: "60px", // Actions column
  },
];

const keys = [
  {
    value: "label",
  },
  {
    value: "customerCount",
    defaultValue: 0,
  },
  {
    value: "vendorCount",
    defaultValue: 0,
  },
];

export const IndustriesTable = () => {
  const { data, isLoading } = useGetAllIndustryData();
  const { mutate: deleteIndustry, isSuccess: deleteSuccess } = useDeleteIndustry();
  const [deletingId, setDeletingId] = useState(false);

  const keysWithActions = [
    ...keys,
    {
      value: "actions",
      CustomComponent: ({ item }) => (
        <IndustriesContextMenu 
          id={item.id}
          customerCount={item.customerCount}
          vendorCount={item.vendorCount}
          setDeletingId={setDeletingId}
        />
      ),
    },
  ];

  const handleClose = () => setDeletingId(false);
  const handleSubmit = () => {
    if (deletingId) {
      deleteIndustry(deletingId);
    }
  };

  useEffect(() => {
    if (deleteSuccess) {
      handleClose();
    }
  }, [deleteSuccess]);

  const prefix = "industries";
  const meta = {
    ...(data?.meta ? data?.meta : {}),
    prefix,
  };

  const headerProps = { items, prefix };
  const bodyProps = { items: data?.rows, keys: keysWithActions };
  const props = { headerProps, bodyProps, meta, isLoading };

  return (
    <>
      <Stack gap="10px" overflow="hidden">
        <HubTableTemplate id="IndustryTable" {...props} />
      </Stack>
      <WarningDeleteDialog
        isOpen={!!deletingId}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="You are about to delete this industry!"
      />
    </>
  );
};

export default IndustriesTable;